import { render, staticRenderFns } from "./detailinfo.vue?vue&type=template&id=3d79ac1e&scoped=true&"
import script from "./detailinfo.vue?vue&type=script&lang=js&"
export * from "./detailinfo.vue?vue&type=script&lang=js&"
import style0 from "./detailinfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detailinfo.vue?vue&type=style&index=1&id=3d79ac1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d79ac1e",
  null
  
)

export default component.exports